// Centralised payment-provider switch.
// Flip via REACT_APP_PAYMENT_PROVIDER in /app/frontend/.env to "stripe" to restore Stripe.
export const PAYMENT_PROVIDER =
  (process.env.REACT_APP_PAYMENT_PROVIDER || "stripe").toLowerCase();

export const IS_QUICKBOOKS = PAYMENT_PROVIDER === "quickbooks";
export const IS_STRIPE = PAYMENT_PROVIDER === "stripe";

export const QB_PAYMENT_URL = process.env.REACT_APP_QB_PAYMENT_URL || "";

export const PROVIDER_LABEL = IS_QUICKBOOKS ? "QuickBooks" : "Stripe";
